/**
 * Zählerstand aus einem Foto lesen (Claude Vision über den lokalen Server).
 * Bewusst nicht kritisch: schlägt die Erkennung fehl — kein Netz, Server
 * down, Timeout — bleibt einfach nichts vorausgefüllt und der Nutzer tippt
 * den Stand wie gewohnt selbst ein. Nichts blockiert, nichts meldet einen
 * Fehler, der den Rundgang unterbricht.
 */
const API_BASIS = import.meta.env.VITE_API_BASIS_URL ?? '';
const TIMEOUT_MS = 15000;

export interface ZaehlerErkennung {
	stand?: string;
	nummer?: string;
}

function istGueltigeErkennung(wert: unknown): wert is ZaehlerErkennung {
	if (typeof wert !== 'object' || wert === null) return false;
	const kandidat = wert as Record<string, unknown>;
	const gueltigesFeld = (f: unknown) => f === undefined || f === null || typeof f === 'string';
	return gueltigesFeld(kandidat.stand) && gueltigesFeld(kandidat.nummer);
}

export async function erkenneZaehlerstand(bildDatenUrl: string): Promise<ZaehlerErkennung | null> {
	const abbruch = new AbortController();
	const timer = setTimeout(() => abbruch.abort(), TIMEOUT_MS);

	try {
		const antwort = await fetch(`${API_BASIS}/api/zaehler-lesen`, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ bildDatenUrl }),
			signal: abbruch.signal
		});
		if (!antwort.ok) return null;

		const daten: unknown = await antwort.json();
		if (!istGueltigeErkennung(daten)) return null;
		return { stand: daten.stand ?? undefined, nummer: daten.nummer ?? undefined };
	} catch {
		return null;
	} finally {
		clearTimeout(timer);
	}
}
